export const TEST_CONFIG = 'test_config'
export const LIVE_RUN = 'live_run'
export const ONLY_TEST_CONFIG_TOOLTIP = 'Only test configs'
export const ONLY_LIVE_RUN_TOOLTIP = 'Only live runs'
